import { render, staticRenderFns } from "./UserServiceIdText.vue?vue&type=template&id=6781a06a&scoped=true"
import script from "./UserServiceIdText.vue?vue&type=script&lang=ts"
export * from "./UserServiceIdText.vue?vue&type=script&lang=ts"
import style0 from "./UserServiceIdText.vue?vue&type=style&index=0&id=6781a06a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6781a06a",
  null
  
)

export default component.exports